import type { Workspace as GraftcodeWorkspace } from '@graft/nuget-gc.webportals.workspaces'

import type { Workspace } from '../types/workspace.types'

export async function workspaceToObject(entity: GraftcodeWorkspace): Promise<Workspace> {
  const [id, name, logoUrl, region, createdAt, lastUsedProjectId] = await Promise.all([
    entity.get_workspaceId(),
    entity.get_name(),
    entity.get_logoUrl(),
    entity.get_region(),
    entity.get_created(),
    entity.get_lastUsedProjectId(),
  ])

  return {
    id,
    name,
    logoUrl: logoUrl ?? null,
    region,
    createdAt: createdAt ?? null,
    lastUsedProjectId: lastUsedProjectId ?? null,
  }
}
